import { render, staticRenderFns } from "./newscheme.vue?vue&type=template&id=557ec976&scoped=true"
import script from "./newscheme.vue?vue&type=script&lang=js"
export * from "./newscheme.vue?vue&type=script&lang=js"
import style0 from "./newscheme.vue?vue&type=style&index=0&id=557ec976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557ec976",
  null
  
)

export default component.exports